var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-progress",class:{ active: _vm.loading },attrs:{"role":"progressbar","aria-hidden":"true"}},[_c('div',{staticClass:"top-progress__bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }